import { AccountPreferences } from 'containers/AccountPreferences'

export default AccountPreferences
